import { createOptionalContext } from '../../../utils/create-optional-context.js';
const [WizardContext, WizardContextConsumer, WizardContextProvider, useWizard,] = createOptionalContext('WizardContext');
export { WizardContext, WizardContextConsumer, WizardContextProvider, useWizard, };
//# sourceMappingURL=wizard-context.js.map